import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Reveal } from "./Reveal";
import { LOCATIONS } from "../../data/site";

const COORDS = {
  chobham: [51.3481, -0.5589],
  longacres: [51.3735, -0.6838],
};

const markerIcon = (label) =>
  L.divIcon({
    className: "cv-marker-wrap",
    html: `
      <div class="cv-marker">
        <span class="cv-pulse"></span>
        <span class="cv-pulse cv-pulse-2"></span>
        <span class="cv-dot"></span>
        <span class="cv-label">${label}</span>
      </div>`,
    iconSize: [18, 18],
    iconAnchor: [9, 9],
  });

export const ShowroomMap = () => {
  const ref = useRef(null);

  useEffect(() => {
    const map = L.map(ref.current, {
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true,
    });

    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(map);

    const entries = LOCATIONS.filter((loc) => COORDS[loc.id]).map((loc) => ({ key: loc.id, loc }));

    entries.forEach(({ key, loc }) => {
      const marker = L.marker(COORDS[key], { icon: markerIcon(loc.place) }).addTo(map);
      const gmaps = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent((loc.address || []).join(", "))}`;
      marker.bindPopup(
        `<div class="cv-popup">
          <p class="cv-popup-kicker">${loc.name}</p>
          <p class="cv-popup-title">${loc.place}</p>
          <p class="cv-popup-addr">${(loc.address || []).join("<br/>")}</p>
          <a class="cv-popup-link" href="${gmaps}" target="_blank" rel="noopener noreferrer">Get directions →</a>
        </div>`,
        { closeButton: false, offset: [0, -6] }
      );
    });

    if (entries.length) map.fitBounds(entries.map((e) => COORDS[e.key]), { padding: [90, 90], maxZoom: 13 });
    else map.setView(COORDS.chobham, 12);

    return () => map.remove();
  }, []);

  return (
    <section className="border-t hairline" data-testid="contact-map-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 lg:pt-20 pb-10 flex flex-wrap items-end justify-between gap-6">
        <Reveal>
          <p className="overline-x mb-4">Two locations · Surrey</p>
          <h2 className="font-display uppercase tracking-tight text-3xl sm:text-4xl text-white">Find us.</h2>
        </Reveal>
        <Reveal delay={0.1} className="flex flex-wrap gap-8">
          {LOCATIONS.map((loc) => (
            <div key={loc.id} className="flex items-center gap-3">
              <span className="cv-legend-dot" />
              <div>
                <p className="text-sm text-white font-medium">{loc.place}</p>
                <p className="font-mono-x text-[10px] tracking-[0.2em] uppercase text-white/45 mt-0.5">{loc.name}</p>
              </div>
            </div>
          ))}
        </Reveal>
      </div>
      <div ref={ref} data-testid="contact-map" className="w-full h-[440px] lg:h-[560px]" />
    </section>
  );
};
